<template>
  <div>
    <v-app-bar
        outlined
        flat
        color="white"
        height="52px"
        style="border-bottom: 1px solid #EDEDED !important;"
    >
      <IconTooltipButtonBottom
          icon="mdi-arrow-left"
          tooltip="Zurück zur Liste"
          id="default"
          width="50px"
          large
          @click="backToList()"
      />
      <v-toolbar-title>Arbeitswissenschaftliche Umfrage</v-toolbar-title>
      <div>
  <!--      <v-btn elevation="0" color="primary"-->
  <!--             @click="sendSurvey(selectedSurveyId)">Umfrage senden</v-btn>-->
      </div>
    </v-app-bar>
    <div class="border-bottom stepper pa-2">
      <v-col class="ma-0 pa-0 d-flex flex-row ml-10">
        <div class="mr-5 mh-100" v-for="step in steps" :key="step.idx">
          <span :class="currentStep === step.idx ? 'focus' : 'no-focus'"
                class="mr-8"
                @click="selectedQuestions.length != 0 && surveyDetails.title != '' ? currentStep =
                step.idx : null"
                :role="selectedQuestions.length != 0 && surveyDetails.title != '' ? 'button' : null"
          >
            <span small :class="currentStep === step.idx ? 'stepper-numbering__focus' :
            'stepper-numbering__no-focus'"
                  class="stepper-numbering">{{
              step.idx }}</span>
            {{ step.text }}
          </span>
        </div>
      </v-col>
    </div>
    <ConfirmDialog ref="backToListDlg" />
    <v-row v-if="currentStep === 1" class="ma-unset">
      <AddSurveyGlobalSetting :currentStep="currentStep" :isIWAKQuestion="true" :surveyDetails="surveyDetails"
                              ref="globalSetting"
                               @changeStep="changeStep(2, true)" />
    </v-row>
    <v-row v-if="currentStep === 2" class="ma-unset">
      <div class="temp-container full-width">
        <v-col class="stepper-main">
          <v-row class="px-12 ma-0">
            <v-col class="pa-0 ma-0">
              <h2>Vorschau der regenerierten Umfrage</h2>
              <p class="text-gray text-description mb-2">Hier ist Ihre regenerierte Umfrage. Überprüfen Sie die Fragen
                und speichern Sie die Umfrage.</p>
            </v-col>
          </v-row>
          <v-row class="mx-12 py-6 temp-content border-10">
            <v-col>
              <v-card flat class="border-10" style="height:fit-content;">
                <v-main class="mx-10 pa-0">
                  <v-col class="ma-0 pa-0 pb-6 d-flex flex-row">
                    <div class="header-box mr-2">
                      <v-icon color="gray">mdi-file-document</v-icon>
                    </div>
                    <div class="d-flex flex-column align-start justify-start">
                      <p class="font-xs text-gray-light ma-0">Umfragetitel</p>
                      <h4 class="text-gray text-right ma-0">{{ surveyDetails.title }}</h4>
                    </div>
                  </v-col>
                  <PXSurvey class="px-survey-preview" :schema="survey.schema" :displayMode="'display'"/>
                </v-main>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <div class="temp-bottom">
          <v-row class="px-12 py-4 ma-0 d-flex flex-row bg-white justify-space">
            <v-col class="pa-0 d-flex justify-start">
              <v-btn text @click.stop="changeStep(1, false)" color="secondary">
                <v-icon>mdi-chevron-left</v-icon>
                Zurück
              </v-btn>
            </v-col>
            <v-col class="pa-0 d-flex justify-end">
              <v-btn elevation="0" @click="resendSurvey" color="primary">Speichern</v-btn>
            </v-col>
          </v-row>
        </div>
      </div>
    <v-snackbar
        v-model="snackbar" timeout="3000" class="mb-12"
    >
      {{ snackbarText }}
    </v-snackbar>
    </v-row>
    <InfoDialog ref="infoDlg" />
  </div>
</template>

<script>
import pxQuestionService from '@/pages/PxQuestionSurvey/PXQuestionsPage/px-question-service'
import surveyGenerator from '@/components/px-survey-generator'
import IconTooltipButtonBottom from '../../../components/common/IconTooltipButtonBottom.vue';
import ConfirmDialog from '@/components/common/ConfirmDialog.vue';
import AddSurveyGlobalSetting from '@/pages/PxQuestionSurvey/PXSurveyPage/AddSurveyGlobalSetting.vue';
import AddSurveyPreview from '@/pages/PxQuestionSurvey/PXSurveyPage/AddSurveyPreview.vue';
import InfoboxTooltip from '@/components/common/InfoboxTooltip.vue';
import {decodeModuleNameByNumber} from '@/components/util.js'
import InfoDialog from "@/components/common/InfoDialog";
import PXSurvey from "@/components/common/PXSurvey.vue"
import pxSurveyService from './px-survey-service';
import SurveySendDialog from './SurveySendDialog.vue';
export default {
  components: {
    ConfirmDialog,
    AddSurveyGlobalSetting,
    AddSurveyPreview,
    InfoboxTooltip,
    InfoDialog,
    PXSurvey,
    IconTooltipButtonBottom,
    SurveySendDialog,
},
  data: () => ({
    steps: [
      {idx: 1, text: 'Titel der Startseite'},
      {idx: 2, text: 'Vorschau'},
    ],
    currentStep: 1,
    selectedModules: [],
    pxQuestions: {},
    modules: [],
    surveyDetails: {
      title: '',
      description: '',
      customTitlePage: false
    },
    schema: {},
    selectedQuestions: [],
    moduleSelected: false,
    personalQuestions: true,
    loading: false,
    selectedModule: null,
    snackbar: false,
    snackbarText: '',
    personalInfoText: "Als Personenstandsdaten werden hier allgemeine Angaben zur Person gesehen, wie z.B. Name, Geschlecht, Alter, etc. Diese Fragen werden in der Regel nur einmalig pro Person abgefragt und sind in weiteren Umfragen nicht mehr notwendig. Ebenso kann über das Deaktivieren dieser Fragen die Rücklaufquote erhöht werden, da Fragen mit starkem persönlichen Bezug vermieden werden. Des weiteren wird die Möglichkeit zur Rückverfolgung einer Person bei kleinen Personengruppen reduziert."
  }),
  props: {},
  computed: {
    survey(){
      return JSON.parse(localStorage.survey);
    }
  },
  mounted() {
    let titlePage = JSON.parse(this.survey.schema).pages[0];
    this.surveyDetails.deadlineDate = null;
    if(titlePage.elements[0].name == "titlePage"){
      let titlePageText = titlePage.elements[0].html;
      this.surveyDetails.description = titlePageText;
    }
    this.surveyDetails.title = this.survey.title;
    this.schema = this.survey.schema;

  },
  methods: {
    decodeModuleNameByNumber: decodeModuleNameByNumber,
      showInfobox() {
        this.$refs['infoBox'].open(this.personalInfoText);
      },
      hideInfobox() {
        this.$refs['infoBox'].close();
      },
      changeStep(changedProp, settingsChanged) {
        if(settingsChanged){
          let titlePageText = surveyGenerator.buildTitlePageForSurvey(this.surveyDetails.description);
          let pages = JSON.parse(this.survey.schema).pages;
          if(pages[0].elements[0].name == "titlePage"){
            this.survey.schema = JSON.parse(this.survey.schema);
            this.survey.schema.pages[0] = titlePageText;
          }else{
            this.survey.schema = pages.unshift(titlePageText);
          }
        } else {
          this.survey.schema = this.schema;
        }
        this.currentStep = changedProp;
      },
      backToList() {
        this.$refs.backToListDlg
            .open(
                "Zurück zur Übersichtsliste",
                "Möchten Sie zurück zur Liste gehen? Diese Umfrage wird verworfen.",
                {width: 500,}
            )
            .then(() => { this.$router.push('/surveys');})
      },
      resendSurvey(){
        this.survey.deadlineDate = this.surveyDetails.deadlineDate;
        this.survey.schema = JSON.stringify(this.survey.schema);

        pxSurveyService.resendSurvey(this.survey)
            .then((response) => {
              this.$refs.infoDlg.open(
                  "Umfrage erneut gespeichert",
                  "Senden Sie die Umfrage wieder"
              ).then(() => { return this.$router.push('/surveys');})
            })
            .catch((error) => {
              console.error(error);
            });
      }
  },
};
</script>
<style scoped>
.v-toolbar__title {
  /*font-weight: 500 !important;*/
}

.stepper {
  height: 40px;
}

.stepper-numbering {
  display: inline-flex;
  width: 20px;
  height: 18px;
  border-radius: 4px;
  padding: 3px 8px;
  margin: 0;
  font-size: 12px;
  justify-content: center;
  margin-right: 8px;
}

.stepper-numbering__focus {
  /*background: var(--v-primary-base);*/
  font-weight: 700;
}

.stepper-numbering__focus::before {
  content:"";
  display: block;
  position: absolute;
  width: 20px;
  border-radius: 4px;
  height: 18px;
  opacity: .1;
  background: var(--v-primary-base);
}

.stepper-numbering__no-focus {
  font-weight: 700;
}

.stepper-numbering__no-focus::before {
  content:"";
  display: block;
  position: absolute;
  width: 20px;
  border-radius: 4px;
  height: 18px;
  opacity: .1;
  background: var(--v-gray_3-base);
}

.focus {
  font-weight: 700 !important;
  color: var(--v-primary-base);
}

.no-focus {
  color: var(--v-gray_3-base);
}

.frame{
    border: 1px solid lightgray;
    margin:5px;
}

.filter{
    width:10%;
    float:right;
    margin-right: 10px;
}

.table-header{
    padding:0 !important;
}

.bottomButton{
    /*width: calc(100% - 20px);*/
    /*margin:10px;*/
}

td{
    vertical-align: middle;
}

tr{
    max-height:25px !important;
}

th{
  background: unset;
  height: unset;
  border: unset;
}
.moduleBtn{
  cursor: pointer;
}
:deep .v-data-table{
  padding: 0 !important;
  height: 40vh;
  overflow: auto;
}
:deep .ql-toolbar.ql-snow+.ql-container.ql-snow{
  height:35vh
}
#selected{
  border: 1px solid var(--v-primary-base) !important;
  border-left: 5px solid var(--v-primary-base) !important;
}
#selected .module-label-icon__container::before{
  background-color: var(--v-primary-base);
}
.module-label-icon__container{
  width: 60px;
  height: 60px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.module-label-icon__container::before{
  content: '';
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  border-radius: 30px;
  width: 60px;
  height: 60px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: .1;
  background-color: var(--gray-color);
}
.module-label-icon__container .v-icon{
  vertical-align: middle;
}
.question-list{
  height: calc(96% - 200px - 38px - 58px);
}
:deep table{
  margin-top: 0 !important;
}
/*:deep .infobox-content {*/
/*  top: 62px;*/
/*  position: absolute;*/
/*  !*right: 20px;*!*/
/*}*/

:deep .infobox-content::after {
  content: " ";
  position: absolute;
  bottom: 100%;  /* At the top of the tooltip */
  left: 43%;
  margin-right: -8px;
  border-width: 8px;
  border-style: solid;
  border-color: transparent transparent white transparent;
}
</style>